import { Messages } from '../../../../codegen/Localize';
import { ISiteUserInfo } from '../../../../ts/models/ISiteUserInfo';
import { siteUserRemove } from '../../../actions/spaces/SiteUserMenuActions';
import { SessionUserSelectors } from '../../../selectors/SessionInfoSelectors';
import { AppState } from '../../../state/AppState';
import { EntityActionNames, IEntityAction } from './IEntityAction';
import { areAllSelectedUsersServerAdmins, isSingleSelectSiteUserGuest } from './IEntityActionHelpers';

export const SiteUserRemoveAction: IEntityAction<ISiteUserInfo, {}> = {
  name: EntityActionNames.SiteUserRemove,
  translateName: Messages.remove_action,
  isVisible: (targetItems: ISiteUserInfo[], state: AppState) => {
     // - Disallow if session user is not allowed (per server setting) to manage users.
    // - Disallow if the only selection is a guest user.
    // - Disallow site admins from attempting to remove a set of all server admins
    return targetItems.length > 0
      && SessionUserSelectors.canManageUsers(state)
      && !isSingleSelectSiteUserGuest(targetItems)
      && (!areAllSelectedUsersServerAdmins(targetItems) || SessionUserSelectors.isSessionServerAdmin(state))
      && state.spaceInfo.spaceType === 'siteusers';
  },
  isClickable: (_availableActions: {}, _targetItems: ISiteUserInfo[], _state: AppState) => {
    return true;
  },
  createReduxAction: (targetItems: ISiteUserInfo[]) => siteUserRemove(targetItems)
};
